import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseService } from '../../../services/auth/firebase.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})

export class NavComponent {
  
  constructor(public firebaseService: FirebaseService, private router: Router){}

  collapsedMenu: boolean = false;

  toggleCollapseMenu(){
    this.collapsedMenu = !this.collapsedMenu
  }

  logOutFirebaseUser(){
    this.firebaseService.logout().then(
      res =>{
        this.firebaseService.navVisibility = false;
        this.router.navigate(['/auth/login'])
      }
    ).catch(
      error => console.error("Firebase error: " + error)
    )
  }
}
